<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Born in Montreal, Don graduated from the Montreal Graphic Arts Technical Foundation in 1979 and decided to move to Nova Scotia that same year. With letter writing being the primary means of communicating with family and friends, Don began writing stories of the farming experiences he encountered. Always the storyteller, Don honed his given ability for a formal presentation of his stories.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?29d46d26